import { supabase } from './supabase';

export interface WhitelistResponse {
  isWhitelisted: boolean;
}

export async function checkWhitelist(email: string): Promise<WhitelistResponse> {
  try {
    // Normalize email before checking
    const normalizedEmail = email.toLowerCase().trim();

    // Call the RPC function directly through Supabase client
    const { data, error } = await supabase.rpc('check_email_whitelist', {
      user_email: normalizedEmail,
    });

    if (error) {
      console.error('Whitelist check error:', error);

      // Provide user-friendly error messages
      if (error.message.includes('Network')) {
        throw new Error('Unable to connect to the server. Please check your internet connection.');
      } else if (error.message.includes('function') && error.message.includes('does not exist')) {
        throw new Error('Whitelist system not configured. Please contact support.');
      } else {
        throw new Error('Unable to verify email. Please try again.');
      }
    }

    // The RPC function returns a boolean directly
    return { isWhitelisted: data === true };
  } catch (error) {
    // Re-throw with more context if it's not already our error
    if (error instanceof Error && !error.message.includes('Unable to')) {
      throw new Error(`Whitelist check failed: ${error.message}`);
    }
    throw error;
  }
}
